import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import SimpleErrorMessage from 'components/InputsMex/containers/SimpleErrorMessage';
import { DropDown } from 'components/InputsMex/inputs';
import {
  SimpleNumberIntInputField,
  SimpleTextInputField,
} from 'components/InputsMex/SimpleInputs';
import { IndexColumn } from 'components/Table/Columns';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import uuid from 'uuid';

const FormBeneficiariosCertificadoPoliza = ({
  porcentajeTotal,
  PORCENTAJES,
  value: beneficiarios,
  onChange,
  validaciones,
  parentescos = [],
}) => {
  const parentMethods = useFormContext();

  const { setError } = parentMethods;

  const methods = useForm({ mode: 'onChange', context: null });

  const onClickAgregar = async (data) => {
    data.uuid = uuid.v4();
    data.porcentaje = Number(data.porcentaje);

    if (beneficiarios.length > 0) {
      const porcentajeActual = porcentajeTotal;
      const newPorcentaje = porcentajeActual + data.porcentaje;
      if (newPorcentaje > PORCENTAJES.MAXIMO) {
        return setError('beneficiarios', {
          type: 'custom',
          message: `No se puede superar el porcentaje máximo de ${PORCENTAJES.MAXIMO}`,
        });
      }
    }
    beneficiarios.push(data);
    methods.setValue('nombre', null);
    methods.setValue('parentesco', null);
    methods.setValue('porcentaje', null);
    methods.clearErrors(['nombre', 'parentesco', 'porcentaje']);
    onChange(beneficiarios);
  };

  const onClickEliminar = (beneficiario) => () => {
    const newBeneficiarios = beneficiarios.filter(
      (item) => item.uuid !== beneficiario.uuid,
    );

    onChange(newBeneficiarios);
  };

  return (
    <React.Fragment>
      <div className="col-12 col-md-11 col-lg-10 mt-3 mb-5">
        <h2>Beneficiarios</h2>
        <h4>
          Por favor ingrese los siguientes datos de sus beneficiarios, considerando
          que la suma del porcetaje de distribución debe ser igual al 100%
        </h4>
        <h4>
          *Una vez completada esta sección se habilitará el botón para generar el
          certificado.
        </h4>
      </div>

      {porcentajeTotal !== 100 && (
        <FormProvider {...methods}>
          <div className="col-11">
            <div className="row justify-content-center">
              <div className="col-sm-6 col-lg-4  align-self-end">
                <SimpleTextInputField
                  label="Nombre"
                  name="nombre"
                  rules={{ required: 'Campo obligatorio' }}
                />
              </div>

              <div className="col-sm-6 col-lg-4  align-self-end">
                <SimpleContainer label="Parentesco" name="parentesco">
                  <DropDown
                    name="parentesco"
                    options={parentescos}
                    rules={{ required: 'Campo obligatorio' }}
                  />
                </SimpleContainer>
              </div>

              <div className="col-sm-6 col-lg-2 align-self-end">
                <SimpleNumberIntInputField
                  label="Porcentaje"
                  name="porcentaje"
                  rules={{
                    required: 'Campo obligatorio',
                    min: {
                      value: 1,
                      message: 'El mínimo es 1',
                    },
                    max: {
                      value: 100 - porcentajeTotal,
                      message: `El máximo es ${100 - porcentajeTotal}`,
                    },
                  }}
                />
              </div>

              <div className="col-sm-6 col-lg-2 align-self-end">
                <button
                  className="btn btn-siguiente-api text-upperca"
                  type="button"
                  onClick={methods.handleSubmit(onClickAgregar)}
                  disabled={
                    beneficiarios.length === validaciones.beneficiarios.maximo
                  }
                >
                  Agregar
                </button>
              </div>
            </div>
          </div>
        </FormProvider>
      )}

      <div className="col-12 col-md-11">
        {(porcentajeTotal === 100 ||
          beneficiarios.length === validaciones.beneficiarios.maximo) && (
          <ul>
            {porcentajeTotal === 100 && (
              <li style={{ fontSize: '17px' }}>Ha alcanzado el porcentaje máximo</li>
            )}

            {beneficiarios.length === validaciones.beneficiarios.maximo && (
              <li style={{ fontSize: '17px' }}>
                Ha alcanzado el máximo de beneficiarios permitidos
              </li>
            )}
          </ul>
        )}

        <SimpleErrorMessage name="listBeneficiarios" />
        <DataTable
          value={beneficiarios}
          className="p-datatable-gridlines p-datatable-sm"
          rowHover
          emptyMessage="No hay beneficiarios ingresados"
          resizableColumns
          autoLayout
        >
          {IndexColumn()}
          <Column header="Nombre" field="nombre" sortable />
          <Column header="Parentesco" field="parentesco" sortable />
          <Column header="Porcetaje" field="porcentaje" sortable />
          <Column
            header="Acciones"
            body={(rowData) => (
              <button
                type="button"
                className="btn btn-primary btn-sm btn-block"
                onClick={onClickEliminar(rowData)}
              >
                Eliminar
              </button>
            )}
          />
        </DataTable>
      </div>
    </React.Fragment>
  );
};

export default FormBeneficiariosCertificadoPoliza;
